import React from "react";
import { compose } from "recompose";
import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

import withLocalization from "../hocs/withLocalization";

const styles = (theme) => ({
    buttonStyle: {
        padding: "5px 10px 0 10px",
    },
    iconTextStyle: {
        fontFamily: "MANEurope, Arial, sans-serif",
        fontSize: theme.typography.pxToRem(10),
        fontStretch: "condensed",
        fontWeight: "bold",
    },
});

const LanguageIcon = withStyles(styles)(({ language, classes: { iconTextStyle } }) => (
    <SvgIcon viewBox="4 4 24 24">
        <g id="icons/language" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fill="#303C49" fillRule="nonzero" id="Shape">
                <polygon points="26 21.4418605 21.7 21.4418605 21.7 25 16 21.4418605 6 21.4418605 6 8.0494186 26 8" />
                <text x="11" y="18" fill="#fff" className={iconTextStyle}>
                    {language}
                </text>
            </g>
        </g>
    </SvgIcon>
));

export const languagesConfig = {
    DE: "Deutsch",
    EN: "English",
};

class LanguageMenu extends React.Component {
    state = {
        anchorEl: null,
    };

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { anchorEl } = this.state;
        const {
            classes: { buttonStyle },
            language,
            setLanguage,
        } = this.props;

        return (
            <div>
                <ButtonBase
                    disableRipple
                    disableTouchRipple
                    className={buttonStyle}
                    aria-owns={anchorEl ? "settings-menu" : null}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                >
                    <LanguageIcon language={language} />
                </ButtonBase>
                <Menu
                    id="settings-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    getContentAnchorEl={null}
                >
                    {Object.keys(languagesConfig).map((lang) => (
                        <MenuItem
                            key={lang}
                            onClick={() => {
                                setLanguage(lang);
                                this.handleClose();
                            }}
                        >
                            {languagesConfig[lang]}
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        );
    }
}

export default compose(withLocalization, withStyles(styles))(LanguageMenu);



// WEBPACK FOOTER //
// ./src/components/LanguageMenu.js